import * as constants from "./constants";

export default function(state, action){
    if (!state || action.type == constants.TAG_CLEAR_STORE){
        state = {
            data: {},
            isLoading: false,
            isSave: false,
            isLoaded: false
        };
    }

    switch(action.type){
        case constants.TAG_NEW_SAVE_START:
            return {...state, ...{isLoading: true, error: undefined}};
        case constants.TAG_NEW_SAVE_SUCCESS:
            return { ...state, ...{data: action.data, isLoading: false, isSave: true}};
        case constants.TAG_NEW_SAVE_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.TAG_SAVE_START:
            return {...state, ...{isLoading: true, error: undefined}};
        case constants.TAG_SAVE_SUCCESS:
            return { ...state, ...{data: action.data, isLoading: false, isSave: true}};
        case constants.TAG_SAVE_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.TAG_DETAIL_START:
            return {...state, ...{isLoading: true, error: undefined}};
        case constants.TAG_DETAIL_SUCCESS:
            return { ...state, ...{data: action.data, isLoading: false, isLoaded: true}};
        case constants.TAG_DETAIL_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        default:
            return state;
    }
}
